<template>
    <div>
        <div v-if="!raw">
            <p>
                Méthode de scraping
                <b-select v-model="request" :options="[
                    {value: 3, text: 'Automatique'}, 
                    {value: 1, text: 'Navigateur'}, 
                    {value: 2, text: 'Interne'},
                    {value: 4, text: 'Le html est dans une colonne'}, 
                    {value: 5, text: 'Le html est dans un fichier'}
                ]" />
            </p>

            <p v-show="request == 4">
                Colonne du html
                <b-input :list="'columns' + id" v-model="column_html" />
                <datalist :id="'columns' + id">
                    <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
                </datalist>   
            </p>

            <p v-show="request == 5">
                Colonne du fichier html
                <b-input :list="'columns' + id" v-model="column_html" />
                <datalist :id="'columns' + id">
                    <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
                </datalist>   
            </p>

            <p>
                Temps maximum de réponse en secondes
                <b-input @change="wait_timeout < 1 ? wait_timeout = 1 : ''; wait_timeout > 120 ? wait_timeout = 120 : ''" type="number" v-model="wait_timeout" min="1" max="120" />
            </p>

            <p>
                Colonne des urls
                <b-input :list="'columns' + id" v-model="column_url" />
                <datalist :id="'columns' + id">
                    <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
                </datalist>            
            </p>

            <p>
                Récupérer les métadonnées
                <b-input v-model="column_metadata" />
            </p>

            <p>
                Récupérer le titre
                <b-input v-model="column_title" />
            </p>

            <p>
                Screenshot
                <b-select :options='["", "haut de page", "toute la page"]' v-model="screenshot" />
            </p>

            <p>
                Listes <b-button variant="link" @click="lists.push({column: '', list: ''})"><i class="fas fa-plus"></i></b-button>
                <b-table v-show="lists.length > 0" striped hover :items="lists" :fields="[
					{
						key: 'column',
						label: 'Colonne',
						thStyle: { width: '40%' }
					},
					{
						key: 'list',
						label: 'Liste',
						thStyle: { width: '40%' }
					},
					{
						key: 'index',
						label: '',
						thStyle: { width: '10%' }
					}
				]">
					<template v-slot:cell(column)="data">
						<b-input v-model="data.item.column" />
					</template>
					<template v-slot:cell(list)="data">
						<b-input :list="'list' + id" v-model="data.item.list" />
                        <datalist :id="'list' + id">
                            <option v-for="(option, idx) in list_lists" :key="'c' + idx">{{ option }}</option>
                        </datalist>
					</template>
					<template #cell(index)="data">
						<b-button variant="link" @click="lists.splice(data.index, 1)"><i class="fa fa-trash" ></i></b-button>
					</template>
				</b-table>            
            </p>

            <p>
                <scraping_actions :root="true" ref="actions" />
            </p>
        </div>
        <div v-else>
            Etape piloté par le studio de scraping
        </div>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

	import element from "../../services/element.js";
	import library from "../../services/library.js";
    import scraping_actions from "./scraping_actions.vue"

    var clone = require("clone");
    
    export default {
        name: "scraping_step",
		components: {
            scraping_actions
		},
		props: {
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
        },
        watch: 
        {
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),

                parameters: {},
                raw: false,

                request: 3,
                column_techno: "",
                lists: [],
                column_metadata: "",
                column_title: "",
                screenshot: "",
                column_url: "url",
                column_html: "",

                list_lists: [],
                columns_data: [],

                wait_timeout: 60
			};
        },
        methods: {
            get_data()
            {
                return this.save()
            },
            save()
            {
                if (this.raw)
                {
                    return this.parameters;                    
                }

                this.wait_timeout = parseInt(this.wait_timeout);

                this.parameters = {
                    "wait_timeout": this.wait_timeout * 1000,
                    "column_url": this.column_url,
                    "actions": [
                        {
                            "name": "action_delete",
                            "delete": [
                                "//script",
                                "//style"
                            ]
                        },
                        {
                            "name": "action_xpath",
                            "xpath": {
                            }
                        },
                        {
                            "name": "action_custom",
                            "code": ""
                        }
                    ],
                };
                if (this.column_metadata)
                {
                    this.parameters.actions[1].xpath[this.column_metadata] = {
                        "xpath": "//meta[@name != \"\"]|//meta[@property != \"\"]",
                        "child": {
                            "name": {
                                "xpath": "/@name",
                                "unique": true
                            },
                            "content": {
                                "xpath": "/@content",
                                "unique": true
                            },
                            "property": {
                                "xpath": "/@property",
                                "column": "name",
                                "unique": true
                            }
                        }
                    };

                    this.parameters.actions[2].code += `

                        var obj = {};
                        line["${this.column_metadata}"] = line["${this.column_metadata}"];

                        for (var i = 0; i < line["${this.column_metadata}"].length; i++)
                        {
                            obj[line["${this.column_metadata}"][i].name] = line["${this.column_metadata}"][i].content;
                        }

                        line["${this.column_metadata}"] = obj;
                    `
                }
                if (this.column_title)
                {
                    this.parameters.actions[1].xpath[this.column_title] = {
                        "xpath": "//title",
                        "unique": true
                    };
                }
                if (this.screenshot)
                {
                    if (this.screenshot == "haut de page")
                    {
                        this.parameters.actions.push({
                            name: "screenshot",
                            column: "screenshot"
                        })
                    }
                    if (this.screenshot == "toute la page")
                    {
                        this.parameters.actions.push({
                            name: "screenshot_full",
                            column: "screenshot"
                        })
                    }
                }

                if (this.lists && this.lists.length > 0)
                {
                    this.parameters.actions.unshift({
                        name: "search_list",
                        lists: this.lists
                    })
                }

                if (this.request == 4)
                {
                    this.parameters.html_column = this.column_html;
                }
                else if (this.request == 5)
                {
                    this.parameters.html_url = this.column_html;
                }
                else if (this.request == 2)
                    this.parameters.request = true;
                else if (this.request == 3)
                    this.parameters.request_if_fail = true;

                var actions = this.$refs.actions.save();

                console.log("actions")
                console.log(actions)

                for (var i = 0; i < actions.length; i++)
                {
                    if (actions[i].name == "action_xpath" && Object.keys(actions[i].xpath).length > 0)
                    {
                        console.log("add")
                        this.parameters.actions.push(actions[i]);
                    }
                }

                var data = {
                    parameters: this.parameters,
                    scraping_step: true,
                    request: this.request,
                    column_metadata: this.column_metadata,
                    column_title: this.column_title,
                    screenshot: this.screenshot,
                    lists: this.lists,
                    actions: actions,
                    column_url: this.column_url,
                    wait_timeout: this.wait_timeout,
                    column_html: this.column_html
                }

                console.log(data)

                return data;
            },
            async load(data)
            {
                var self = this;

                console.log("load scraping " + this.id)
                
                if (!data)
                {
                    return;
                }

                console.log(data)

                if (data.hasOwnProperty("parameters"))
                {
                    this.parameters = data.parameters;
                    this.request = data.request;
                    this.column_metadata = data.column_metadata;
                    this.column_title = data.column_title;
                    this.screenshot = data.screenshot;
                    this.lists = data.lists || [];
                    this.column_url = data.column_url || "url";
                    this.wait_timeout = data.wait_timeout || 60;
                    this.column_html = data.column_html || "";
                    if (data.column_techno)
                        this.lists.push({column: data.column_techno, list: "Technos"});

                    await this.$nextTick();

                    this.$refs.actions.load(data.actions);
                }
                else
                {
                    this.raw = true;
                    this.parameters = data;                
                }
            },
        },
        async mounted()
        {		
            var lists = await element.getby_production("list");
			var lists = lists.element;

			for (var i = 0; i < lists.length; i++)
			{
				this.list_lists.push(lists[i].libelle)
			}        
        }
    }
</script>

<style scoped>
</style>